module.exports = __webpack_public_path__ + "mainassets/img/dot-group-hero.3ebddcfd.svg";